<ul>
  <li><strong>type:</strong> {{ translationPrefix() + 'type' | translate }}</li>
  <li><strong>volume: </strong>{{ translationPrefix() + 'volume' | translate }}</li>
  <li><strong>volume_unit_measure: </strong>{{ translationPrefix() + 'volume_unit_measure' | translate }}</li>
  <li><strong>name: </strong>{{ translationPrefix() + 'name' | translate }}</li>
  <li><strong>purchase_date: </strong>{{ translationPrefix() + 'purchase_date' | translate }}</li>
  <li><strong>purchase_price: </strong>{{ translationPrefix() + 'purchase_price' | translate }}</li>
  <li><strong>purchase_currency: </strong>{{ translationPrefix() + 'purchase_currency' | translate }}</li>
</ul>
